import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType,  axiosDelete, axiosGet, axiosPost, axiosPut,postFile } from './axiosUtils';
import './axiosInterceptor';

const intermediateMeasurementService = {
  async addIntermediateMeasurement(payload: FormData) : AxiosUtilsType {
    return await postFile(`intermediateMeasurement/add`, payload);
  },

  async getIntermediateMeasurement(recId: DynamicObjectInterface) {
    return await axiosGet(`intermediateMeasurement/retrieve/${recId}`);
  },

  async getIntermediateMeasurementList(payload: DynamicObjectInterface) {
    return await axiosPost(`intermediateMeasurement/list`, payload);
  },

  async updateIntermediateMeasurement(recId: DynamicObjectInterface, payload: DynamicObjectInterface) {
    return await axiosPut(`intermediateMeasurement/update/${recId}`, payload);
  },

  async deleteIntermediateMeasurement(recId: DynamicObjectInterface) {
    return await axiosDelete(`intermediateMeasurement/delete/${recId}`);
  },
};
export default intermediateMeasurementService;
